import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-attributes-help',
    templateUrl: './attributes-help.component.html',
    styleUrls: ['./attributes-help.component.scss']
})
export class AttributesHelpComponent {
    @Input() attributeKeys: string[];
    @Output() afterClose = new EventEmitter<void>();
}
